import {BatchSearchService } from './batch-search.service'
import { Project } from './project'

export class BatchSearch {
  id: string
  date: Date
  dbLs: string[]
  filename: string
  searches: string[]
  doneSearches: Object
  isCurrentSearch: boolean

  constructor(
    private bss: BatchSearchService,
    public project: Project,
    tpl: [string, boolean, Object]) {
    this.filename = tpl[0]
    this.isCurrentSearch = tpl[1]
    let obj = tpl[2]
    this.id = obj['id']
    this.date = new Date(obj['date'])
    this.dbLs = obj['db']
    this.searches = obj['searches']
    this.doneSearches = obj['doneSearches'] || {}
    this.project.batchSearchMap.set(this.id, this)
  }

  get doneSummary() {
    let kkk = Object.keys(this.doneSearches)
    let ls=[]
    kkk.sort((a, b) => a < b ? -1 : 1)
    kkk.forEach(k => ls.push(`${k}: ${this.doneSearches[k].length}`))
    return (ls.length ? "Done: ":"")+ls.join('; ')
  }
}



// WEBPACK FOOTER //
// ./src/app/batch-search.ts